import { styled, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Avatar } from "@mui/material";
import Rating from "@mui/material/Rating";

export const RatingContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: "10px",
  paddingBottom: "5px"
});

export const StarRating = styled(Rating)({
  "& .MuiRating-icon": {
    fontSize: "2.5rem",
  },
  "& .MuiRating-iconFilled": {
    color: "#ffc107",
  },
  "& .MuiRating-iconHover": {
    color: "#ffb300",
  },
  "& .MuiRating-iconEmpty": {
    color: "#e0e0e0",
  },
});

export const RatingLabel = styled(Typography)({
  marginTop: "8px",
  fontSize: "1rem",
  fontWeight: 700,
  color: "#1565c0",
  backgroundColor: "#e3f2fd",
  padding: "4px 10px",
  borderRadius: "999px",
});

export const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "12px",
    padding: "8px",
    minWidth: "400px",
  },
});

export const DialogTitleStyled = styled(DialogTitle)({
  textAlign: "center",
  padding: "16px 24px 8px",
  "& .MuiTypography-h6": {
    fontWeight: 600,
    fontSize: "1.25rem",
  },
});

export const DialogContentStyled = styled(DialogContent)({
  padding: "16px 24px",
});

export const DialogActionsStyled = styled(DialogActions)({
  padding: "8px 24px 16px",
  justifyContent: "center",
  gap: "12px",
});

export const CancelButton = styled(Button)({
  padding: "8px 24px",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 500,
});

export const DoneButton = styled(Button)({
  padding: "8px 24px",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 600,
  backgroundColor: "#1976d2",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#1565c0",
  },
});

export const AlreadyReviewedLabel = styled(Typography)({
  marginTop: "8px",
  fontSize: "0.85rem",
  color: "#4caf50",
  fontWeight: 500,
});

export const EmployeeAvatar = styled(Avatar)({
  width: 88,
  height: 88,
  marginBottom: 8,
});

export const CompanyAvatar = styled(Avatar)({
  width: 88,
  height: 88,
  marginBottom: 8,
});

export const AvatarRow = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  paddingTop: "6px",
  paddingBottom: "8px",
});

